export default class Delegate {
    constructor() {
        this.subscribers = [];
    }

    // Subscribe a function
    subscribe(fn) {
        this.subscribers.push(fn);
    }

    // Unsubscribe a function
    unsubscribe(fn) {
        const index = this.subscribers.indexOf(fn);
        if (index > -1) {
            this.subscribers.splice(index, 1);
        }
    }

    // Invoke all subscribed functions
    invoke(...args) {
        for (const subscriber of this.subscribers) {
            subscriber(...args);
        }
    }
}
